import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
`

export const EventsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
  max-height: ${props => props.height + 'px'};
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp16};
  overflow: hidden;
  visibility: visible;
  transition: max-height 0.3s ease-in-out;

  ${props =>
    props.collapsed &&
    css`
      visibility: hidden;
      max-height: 0px;
      margin-bottom: 0px;
    `}
`
